<template lang="pug">
  include ../mixins
  ui-click-outside(:do="close")
    +b.lang-switch(:class="[itemClass]")
      +e.BUTTON.current(
        type="button"
        aria-haspopup="true"
        :aria-expanded="isOpen ? 'true' : 'false'"
        @click="toggle"
        :class="{ 'is-open': isOpen }"
      )
        +e.SPAN.label {{ currentLanguage.title }}
        +e.SPAN.arrow
      +e.list(v-show="isOpen")
        +e.A.option(
          v-for="lang in languagesList"
          :key="lang.code"
          :href="lang.href"
          :hreflang="lang.code"
          :aria-current="lang.code === currentLang ? 'true' : null"
          :class="{ 'is-active': lang.code === currentLang }"
          @click.prevent="handleLanguage(lang.code)"
        ) {{ lang.title }}
</template>

<script>
import { languageHref } from '@helpers/url'

export default {
  name: 'language-list',
  props: {
    itemClass: {
      type: String,
      default: 'lang-switch--common',
    },
  },
  data() {
    return {
      isOpen: false,
      currentLang: window.language,
      languagesList: [
        { title: 'UA', code: 'uk' },
        { title: 'RU', code: 'ru' },
        { title: 'EN', code: 'en' },
      ].map(lang => ({ ...lang, href: languageHref(lang.code) })),
    }
  },
  computed: {
    currentLanguage() {
      return (
        this.languagesList.find(lang => lang.code === this.currentLang) ||
        this.languagesList[0]
      )
    },
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen
    },
    close() {
      this.isOpen = false
    },
    handleLanguage(selectedLang) {
      window.location.replace(languageHref(selectedLang))
    },
  },
}
</script>
